import { TimerPlusIcon } from './TimerPlusIcon';

/**
 * author: Colton Wiscombe
 * id 2C80851E-E2B2-4CB3-9B95-A7807473F48C
 * name timer-plus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-plus.svg
 * tags
 * - Date / Time 
 */
export const TimerAddIcon = TimerPlusIcon;
export default TimerAddIcon